import React, { useState } from "react";
import { Box } from "@mui/material";
import Tabs from "../../components/Tabs/Tabs";
import Tab from "../../components/Tab/Tab";
import TabPanel from "../../components/TabPanel/TabPanel";
import AllTags from "../ManageTag/AllTags.js";
import AllActivities from "./AllActivities.js";

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const ActivityTagLanding = () => {
  // State: Which tab is active?
  const [tabIndex, setTabIndex] = useState(0);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Tabs value={tabIndex} onChange={handleTabChange} aria-label="Activity/Tag Tabs">
        <Tab label="Tags" {...a11yProps(0)} />
        <Tab label="Activity" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <AllTags />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <AllActivities />
      </TabPanel>
    </Box>
  );
};

export default ActivityTagLanding;
